import { render } from "./ValidateOrderDialog.vue?vue&type=template&id=5c0d7064"
import script from "./ValidateOrderDialog.vue?vue&type=script&lang=js"
export * from "./ValidateOrderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__